import type { PageContent } from "../types";

export const p_video_and_visual_search: PageContent = {
  slug: "video-and-visual-search",
  title: `Video and Visual Search | Phil Carr SEO Consultant`,
  description: `During 2021, video consumption surged as remote work and social distancing kept people at home. Platforms like YouTube, TikTok and Instagram became primary sources of…`,
  date: "",
  lastUpdated: "2026-06-25",
  body: `# Video and Visual Search

![Video and Visual Search featured image](/images/blog/generated/video-and-visual-search.jpg)

**Published:** June 15, 2021

## The Growth of Video Content

During 2021, video consumption surged as remote work and social distancing kept people at home. Platforms like YouTube, TikTok and Instagram became primary sources of entertainment, education and product discovery.

Search engines began incorporating video snippets and key moments into results. This trend encouraged brands to produce more video content—tutorials, product demos, webinars and behind‑the‑scenes glimpses—to engage audiences and improve search visibility.

## Optimising for Visual Search

Visual search technologies allow users to search using images rather than words. Although still in its early stages, this technology gained momentum as retailers integrated visual search into their apps.

To prepare, ensure that your product images are high quality, accurately labelled and accompanied by descriptive alt text. Use structured data such as schema markup for products, recipes and videos to help search engines understand your content.

When creating video content, include captions and transcripts to enhance accessibility and indexability.

## The Rise of Key Moments

Google introduced the ability to highlight key moments within a video, allowing users to jump directly to the section that answers their query. To take advantage of this, structure your videos with clear chapters or timestamps and provide a text outline in the description.

This helps search engines identify relevant segments, improving the likelihood of your video appearing in results.

## SEO Takeaways and Next Steps

Video and visual search present exciting opportunities to reach audiences in new ways. If you’d like assistance planning a video strategy or implementing structured data for visual search, contact info@phil‑carr.co.uk or 01226 697 325.

If you need help with your SEO strategy, get in touch by emailing [info@phil-carr.co.uk](mailto:info@phil-carr.co.uk) or calling 01226 697 325.

## Key Takeaways

- **The Growth of Video Content:** During 2021, video consumption surged as remote work and social distancing kept people at home.
- **Optimising for Visual Search:** Visual search technologies allow users to search using images rather than words.
- **The Rise of Key Moments:** Google introduced the ability to highlight key moments within a video, allowing users to jump directly to the section that answers their query.

## Update — June 2026

Refreshed in June 2026. The E-E-A-T signals Google leans on have become more granular — clear authorship, verifiable experience, and dated updates like this one now carry more visible weight in quality rater feedback than they did a year ago.

## About the author

Phil Carr is an SEO consultant and web strategist focused on helping businesses
grow through technical optimisation, content strategy, and data-driven decision making. His
work combines hands-on experience with ongoing research into algorithm updates and emerging
search trends.

[Read Phil’s bio](/#authorModal)

## Other News Articles

[![2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns featured image](/images/blog/generated/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns.jpg)](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

### [2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

[![2023 SEO Lessons and Forward View featured image](/images/blog/generated/2023-seo-lessons-and-forward-view.jpg)](/blog/2023-seo-lessons-and-forward-view)

### [2023 SEO Lessons and Forward View](/blog/2023-seo-lessons-and-forward-view)

[![A Practical Plan for AI-Driven Search – A Ninety Day Playbook featured image](/images/blog/generated/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook.jpg)](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

### [A Practical Plan for AI-Driven Search – A Ninety Day Playbook](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

[![Looking Ahead: Lessons from 2024 for the Future featured image](/images/blog/generated/looking-ahead-lessons-from-2024-for-the-future.jpg)](/blog/looking-ahead-lessons-from-2024-for-the-future)

### [Looking Ahead: Lessons from 2024 for the Future](/blog/looking-ahead-lessons-from-2024-for-the-future)

We use cookies to improve your experience, analyse site traffic, and understand how you interact with
our content. Read our [cookie policy](/cookies) to learn more.

Reject optionalAccept cookies [Privacy policy](/privacy-policy)

reCAPTCHA

Recaptcha requires verification.

protected by **reCAPTCHA**`,
};
